<div class="modal" tabindex="-1" role="alertdialog" id="loadingScreenDiv" data-backdrop="false" data-keyboard="false" [ngStyle]="{'display':display}" [attr.aria-label]="lms.get('ALERT_HEADING')" aria-describedby="alertMessage">
    <div class="modal-dialog modal-dialog-full-width" role="document">
        <div class="modal-content modal-content-full-width">
            <div id="loadingScreenText" tabindex="-1">
                <p>{{lms.get('LOADING_ELLIPSIS')}}</p><span class='fas fa-spinner fa-pulse'></span>
            </div>
        </div> 
    </div>
</div>
